import {ContentUserProductionRewardSearchOption} from "../../search-option/content/ContentUserProductionRewardSearchOption"

/**
 * 와글와글 보상 프리셋 검색, 계수 요청 URL 인자 구성 요소 설명
 */
export const ContentUserProductionRewardSearchOptionDescription: Record<keyof ContentUserProductionRewardSearchOption, string> = {
    idNeq: '기본키 불일치',
    idMin: '기본키 최소',
    idMax: '기본키 최대',
    creatorIdEq: '생성자 ID 일치',
    creatorIdNeq: '생성자 ID 불일치',
    creatorIdMin: '생성자 ID 최소',
    creatorIdMax: '생성자 ID 최대',
    valueNeq: '지급 솔라 불일치',
    valueMin: '지급 솔라 최소',
    valueMax: '지급 솔라 최대',
    displayOrderNeq: '표시 순서 불일치',
    displayOrderMin: '표시 순서 최소',
    displayOrderMax: '표시 순서 최대',
    createdAtEq: '생성일 일치',
    createdAtNeq: '생성일 불일치',
    createdAtMin: '생성일 최소',
    createdAtMax: '생성일 최대',
}
